import { atom } from "jotai";
import {
  currentTimeSavedAtomFamily,
  TimeValue,
  hasTimeSavedBeenModifiedAtomFamily,
} from "./zapAssetMetadataAtomFamily_SUSPENDS";

export const updateAssetMetadataSetter = atom(
  null,
  async (
    _,
    set,
    {
      zapId,
      metadataName,
      assetType,
      metadataValue,
    }: {
      zapId: string;
      metadataName: string;
      assetType: string;
      metadataValue: TimeValue;
    },
  ) => {
    // Optimistic update: immediately update the UI with the new value
    // This prevents text in put and dropdown delays and gives instant feedback to users
    set(currentTimeSavedAtomFamily(zapId), metadataValue);
    set(hasTimeSavedBeenModifiedAtomFamily(zapId), true);

    await fetch(`/api/canvas/v1/asset-metadata/`, {
      method: "POST",
      body: JSON.stringify({
        asset_type: assetType,
        asset_id: zapId,
        metadata_name: metadataName,
        metadata_value: metadataValue,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
);
